<template>
    <v-data-table v-bind="{ headers, items }" disable-filtering disable-pagination disable-sort hide-default-footer :items-per-page="-1" class="v-sheet--outlined">
        <template #top>
            <v-subheader>DigiKey Client Credentials</v-subheader>
            <v-divider />
        </template>

        <template #[`item.client_id`]="{item}">
            <v-text-field v-model="item.client_id" v-bind="attrs_input__table" @input="emit" />
        </template>
        <template #[`item.client_secret`]="{item}">
            <v-text-field v-model="item.client_secret" v-bind="attrs_input__table" @input="emit" />
        </template>
        <template #[`item.isActive`]="{ item }">
            <v-switch v-model="item.isActive" class="d-inline-block ml-1 mr-n3" v-bind="attrs_switch" @change="emit" />
        </template>
        <template #[`item.pull`]="{ item }">
            <v-btn text icon tile width="48" height="48" color="red" @click="pull(item)">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
        </template>

        <template #footer>
            <v-divider />
            <v-row no-gutters>
                <v-spacer />
                <v-col cols="auto">
                    <v-btn text icon tile width="48" height="48" color="primary" @click="push">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-data-table>
</template>

<script>
import { attrs_input__table, attrs_switch } from "@/assets/variables/attrs";
import { initDataTableHeaders, initManufacturingVendorDigikey, initManufacturingVendorDigikeyCredential } from "@/assets/variables/inits";

const headers = initDataTableHeaders([
    { text: "client_id", value: "client_id", cellClass: "pa-0" },
    { text: "client_secret", value: "client_secret", cellClass: "pa-0" },
    { text: "사용여부", value: "isActive", align: "center", width: 100 },
    { text: "", value: "pull", cellClass: "pa-0" },
]);

export default {
    props: {
        value: { type: Object, default: initManufacturingVendorDigikey },
    },
    data: () => ({
        form: initManufacturingVendorDigikey(),

        headers,
        attrs_switch,
        attrs_input__table,
    }),
    computed: {
        items() {
            return this.form?.credentials;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initManufacturingVendorDigikey(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        push() {
            this.form.credentials.push(initManufacturingVendorDigikeyCredential());
            this.emit();
        },
        pull(item) {
            let index = this.form.credentials.findIndex(({ tempId }) => tempId == item.tempId);
            if (0 <= index) this.form.credentials.splice(index, 1);
            this.emit();
        },
    },
};
</script>
